<div class="pagination-container d-flex justify-content-between mt-4">
    <div class="pagination">
      <ul class="pagination-list d-flex">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <button class="page-link" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1">&laquo;</button>
        </li>
        <li class="page-item" *ngFor="let page of [].constructor(totalPages); let i = index" [class.active]="i + 1 === currentPage">
          <button class="page-link" (click)="onPageChange(i + 1)">
            {{ i + 1 }}
          </button>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <button class="page-link" (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages">&raquo;</button>
        </li>
      </ul>
    </div>
  
    <div class="">
      <select class="form-select txt-dark" id="itemsPerPage" [(ngModel)]="pageSize" (change)="onItemsPerPageChange(pageSize)">
        <option *ngFor="let size of [5, 10, 20, 30]" [value]="size">{{ size }}</option>
      </select>
    </div>
  </div>
  